import React from 'react';
import { useTranslation } from 'react-i18next';
import { getPillStatusFromRating } from 'commons/src/commonFunctions';
import StatusPill from 'commons/src/components/pills/StatusPill';
import { SensorStatusWithIcon } from 'commons/src/components/sensors/SensorStatusDot';
import { PillStatus, SensorTypes } from 'commons/src/models/commonEnums';
import { formatRangeText } from 'commons/src/sensorRatingUtils';
import { ReportSensorThresholds } from '../../../../models/common';
import styles from '../SensorsView.module.scss';

export type SensorHeaderProps = {
    sensor: SensorTypes;
    thresholds: ReportSensorThresholds;
};

export const SensorHeader: React.FC<SensorHeaderProps> = ({ sensor, thresholds }) => {
    const { t: txt } = useTranslation();
    const sensorName = txt(sensor);

    return (
        <div className={styles.sensorHeader}>
            <div className={styles.sensorTitle}>
                <SensorStatusWithIcon sensor={sensor} />
                <h2 className={styles.sensorName}>{sensorName}</h2>
            </div>
            <div className={styles.ratingLegend}>
                {thresholds.ranges
                    .map(range => {
                        const rangeText = formatRangeText(range, thresholds.unit);
                        return { range, rangeText };
                    })
                    .filter(({ rangeText }) => rangeText !== '')
                    .map(({ range, rangeText }) => {
                        const pillStatus = getPillStatusFromRating(range.rating) || PillStatus.success;
                        const rangeKey = `${range.rating}-${range.from ?? 'min'}-${range.to ?? 'max'}`;

                        return (
                            <div key={rangeKey} className={styles.legendItem}>
                                <div className={styles.legendPillContainer}>
                                    <StatusPill status={pillStatus} size="small" outline />
                                    <span className={styles.legendRange}>{rangeText}</span>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};
